module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "header-action"
  }, [_c('div', {
    staticClass: "form-group search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.plate),
      expression: "plate",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "mask-plate",
      rawName: "v-mask-plate"
    }],
    staticClass: "form-control upper",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "data-vv-validate-on": "blur",
      "autofocus": "autofocus",
      "placeholder": "Informe a placa do veículo"
    },
    domProps: {
      "value": (_vm.plate)
    },
    on: {
      "change": function($event) {
        _vm.plate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-search-input"
  })])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "alert alert-warning alert-container",
    staticStyle: {
      "background": "#FCDEC1"
    }
  }, [_c('p', {
    staticClass: "no-margin",
    staticStyle: {
      "color": "#795336"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.msgErrorBold))]), _vm._v(" " + _vm._s(_vm.msgError) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.msgError = undefined
      }
    }
  }, [_c('i', {
    staticClass: "icon-cross icon-close-modal"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.vehicle) ? _c('div', {
    staticClass: "content-box-npadd desk"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "cell-plate info-car"
  }, [_c('span', {
    directives: [{
      name: "mask-plate",
      rawName: "v-mask-plate"
    }]
  }, [_vm._v(_vm._s(_vm.vehicle.plate))])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.vehicle.tagSerialNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.nodelName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.brandName))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-box"
  }, [_c('dropdown', {
    staticClass: "dropdown-lg dropdown-axes",
    attrs: {
      "options": _vm.axes,
      "value": _vm.vehicle.category,
      "fieldValue": "category_artesp_id"
    },
    model: {
      value: (_vm.axesId),
      callback: function($$v) {
        _vm.axesId = $$v
      },
      expression: "axesId"
    }
  })], 1)])])])]), _vm._v(" "), (_vm.vehicle.companyName != null) ? _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.vehicle.companyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicle.companyTradeName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.vehicle.taxIdNumber)))])])])]) : _c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.vehicle.personName + ' ' + _vm.vehicle.personLastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.vehicle.taxIdNumber)))])])])])]) : _vm._e(), _vm._v(" "), (_vm.vehicle) ? _c('div', {
    staticClass: "content-box-npadd mob"
  }, [_c('div', {}, [_c('p', {
    staticClass: "cell-plate info-car inline"
  }, [_vm._v("\n        Placa:\n        "), _c('span', {
    directives: [{
      name: "mask-plate",
      rawName: "v-mask-plate"
    }]
  }, [_vm._v(_vm._s(_vm.vehicle.plate))])]), _vm._v(" "), _c('p', {
    staticClass: "inline"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TAG Nº: ")]), _vm._v("\n        " + _vm._s(_vm.vehicle.tagSerialNumber) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "inline bold"
  }, [_vm._v(_vm._s(_vm.vehicle.brandName))]), _vm._v(" "), _c('div', {
    staticClass: "input-box inline"
  }, [_c('dropdown', {
    staticClass: "dropdown-lg dropdown-axes",
    attrs: {
      "options": _vm.axes,
      "value": _vm.vehicle.category,
      "fieldValue": "category_artesp_id"
    },
    model: {
      value: (_vm.axesId),
      callback: function($$v) {
        _vm.axesId = $$v
      },
      expression: "axesId"
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.vehicle.personName + ' ' + _vm.vehicle.personLastName))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CNPJ: ")]), _vm._v("\n      " + _vm._s(_vm._f("cpfCnpj")(_vm.vehicle.taxIdNumber)) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.enableRNTRC) ? _c('div', {
    staticClass: "col-xs-12 margin-t20"
  }, [_c('p', {
    staticClass: "no-margin"
  }), _c('div', {
    staticClass: "content-box-npadd"
  }, [_c('div', {
    staticClass: "content-grey"
  }, [_c('p', {
    staticClass: "bold margin-t10 margin-b0"
  }, [_vm._v("Dados do transportador")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control",
    class: {
      'has-error': _vm.errors.has('rntrcDocument')
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "mask-cpf-cnpj",
      rawName: "v-mask-cpf-cnpj"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.rntrcDocument),
      expression: "rntrcDocument",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cpfCnpj'),
      expression: "'required|cpfCnpj'"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
      "name": "rntrcDocument",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.rntrcDocument)
    },
    on: {
      "change": function($event) {
        _vm.rntrcDocument = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('rntrcDocument')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "margin-top": "15px",
      "gap": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-back",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.cancelRNTRC
    }
  }, [_vm._v("\n                Cancelar\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.validateDocument
    }
  }, [_vm._v("\n                Validar\n              ")])])])])]), _vm._v(" "), _c('p')]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Dados do Veículo")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("TAG Nº")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Modelo")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Marca")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Eixos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Dados do agregador")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Razão Social")]), _vm._v(" "), _c('th', [_vm._v("Nome fantasia")]), _vm._v(" "), _c('th', [_vm._v("CNPJ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Dados do agregador")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Transportador")]), _vm._v(" "), _c('th', [_vm._v("CPF")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("CPF/CNPJ do RNTRC:")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-811ae500!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/toll-ticket/vehicle-aggregate.vue
// module id = 2185
// module chunks = 1